@if (isTileLayout()) {
    @if (isDateField()) {
        <st-date-range-pager
            #dateRangePager
            [period]="tileViewDateRange()"
            [dayCount]="7" />
    } @else {
        <st-pager
            pageSize="7"
            [totalCount]="totalGroupCount()"
            (startIndexChange)="onStartIndexChange($event)" />
    }
}
@if (isMapLayout()) {
    <button
        mat-icon-button
        class="st-playbook-right-slot-icon__zoom"
        [matTooltip]="languageSettings.PSTWebZoomToCoverageLabel"
        (click)="zoomToCoverage()">
        @if (viewStateMapZoomToCoverage()) {
            <mat-icon>center_focus_strong</mat-icon>
        }
        @if (!viewStateMapZoomToCoverage()) {
            <mat-icon class="material-symbols-outlined">center_focus_strong</mat-icon>
        }
    </button>
    <button
        mat-icon-button
        class="st-playbook-right-slot-icon__people"
        [matTooltip]="languageSettings.PSTWebShowTeamLocationsLabel"
        (click)="showTeamLocations()">
        @if (viewStateMapShowTeamLocations()) {
            <mat-icon>people</mat-icon>
        }
        @if (!viewStateMapShowTeamLocations()) {
            <mat-icon class="material-symbols-outlined">people</mat-icon>
        }
    </button>
    <button
        mat-icon-button
        class="st-playbook-right-slot-icon__lock"
        [matTooltip]="languageSettings.PSTWebLockMapLocationLabel"
        (click)="lockMapLocation()">
        @if (viewStateMapLockMapLocation()) {
            <mat-icon>lock</mat-icon>
        }
        @if (!viewStateMapLockMapLocation()) {
            <mat-icon class="material-symbols-outlined">lock_open</mat-icon>
        }
    </button>
}
